import React, { useState, createContext, useContext, ReactNode, FormEvent } from 'react'
import PropTypes from 'prop-types'

interface InfoContextProps {
	infoData: any,
	updateInfo: any,
	updateAccentColor: any,
	updateSocialColor: any,
	updateFontColor: any,
	toggleReferral: any
}

interface InfoProviderProps {
	children: ReactNode,
}


export const InfoContext = createContext<Partial<InfoContextProps>>({})

export const InfoProvider = ({ children }: InfoProviderProps) => {
	const [state, setState] = useState({
		showReferral: true,
		referralText: 'Create your own free email signature',
		portrait: 'https://i.pravatar.cc/?img=49',
		logo: '',
		firstName: 'Clara',
		lastName: 'Smith',
		jobTitle: 'VP of Growth',
		department: 'Marketing',
		companyName: 'Design Buffs',
		officePhone: '+44 7557 877 683',
		mobilePhone: '+44 7557 877 683',
		websiteUrl: 'www.designbuffs.com',
		emailAddress: 'hello@designbuffs.com',
		address: '33 King\'s Rd, Reading RG1 3AR, United Kingdom',
		socialLinkedin: 'linkedin.com/company/design-buffs',
		socialFacebook: 'facebook.com/designbuffs/',
		socialTwitter: 'twitter.com/designbuffs',
		socialInstagram: 'instagram.com/daddy_of_sidney/',
		accentColor: '#311b92',
		socialColor: '#e91e63',
		fontColor: '#000000',
	})
	return (
		<InfoContext.Provider
			value={{
				infoData: state,
				updateInfo: (e: FormEvent<HTMLInputElement>) => {
					setState({
						...state,
						[e.currentTarget.name]: e.currentTarget.value,
					})
				},
				updateAccentColor: (color: string) => {
					setState({
						...state,
						accentColor: color,
					})
				},
				updateSocialColor: (color: string) => {
					setState({
						...state,
						socialColor: color,
					})
				},
				updateFontColor: (color: string) => {
					setState({
						...state,
						fontColor: color,
					})
				},
				toggleReferral: (e: FormEvent<HTMLInputElement>) => {
					setState({
						...state,
						showReferral: e.currentTarget.checked
					})
				},
			}}
		>
			{children}
		</InfoContext.Provider>
	)
}

export const useInfoValue = () => useContext(InfoContext)

InfoProvider.propTypes = {
	children: PropTypes.node,
}
